import React from 'react'

const CalendarIcon = ({ mainColor, secColor, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fill={secColor}
        d="M7,5.99976C6.44803,6.00007,6.00031,5.55287,6,5.0009c0-0.00038,0-0.00076,0-0.00114v-2
	c0-0.55228,0.44772-1,1-1s1,0.44772,1,1v2c0.00031,0.55197-0.44689,0.99969-0.99886,1C7.00076,5.99976,7.00038,5.99976,7,5.99976z
	 M17,5.99976c-0.55197,0.00031-0.99969-0.44689-1-0.99886c0-0.00038,0-0.00076,0-0.00114v-2c0-0.55228,0.44772-1,1-1s1,0.44772,1,1
	v2c0.00031,0.55197-0.44689,0.99969-0.99886,1C17.00076,5.99976,17.00038,5.99976,17,5.99976z"
      />
      <path
        fill={mainColor}
        d="M19,4.00024h-1v0.99952c0,0.55228-0.44772,1-1,1s-1-0.44772-1-1V4.00024H8v0.99952c0,0.55228-0.44772,1-1,1
	s-1-0.44772-1-1V4.00024H5c-1.65685,0-3,1.34315-3,3v2h20v-2C22,5.34339,20.65685,4.00024,19,4.00024L19,4.00024z"
      />
      <circle cx="7" cy="13" r="1" fill={mainColor} />
      <circle cx="7" cy="17" r="1" fill={mainColor} />
      <circle cx="12" cy="13" r="1" fill={mainColor} />
      <circle cx="12" cy="17" r="1" fill={mainColor} />
      <circle cx="17" cy="13" r="1" fill={mainColor} />
      <circle cx="17" cy="17" r="1" fill={mainColor} />
      <path
        fill={secColor}
        d="M2,9.00024v10c0,1.65685,1.34315,3,3,3h14c1.65685,0,3-1.34315,3-3v-10H2z M7,18.00024
	c-0.55228,0-1-0.44772-1-1s0.44772-1,1-1s1,0.44772,1,1S7.55228,18.00024,7,18.00024z M7,14.00024c-0.55228,0-1-0.44771-1-1
	s0.44772-1,1-1s1,0.44771,1,1S7.55228,14.00024,7,14.00024z M12,18.00024c-0.55229,0-1-0.44772-1-1s0.44771-1,1-1s1,0.44772,1,1
	S12.55229,18.00024,12,18.00024z M12,14.00024c-0.55229,0-1-0.44771-1-1s0.44771-1,1-1s1,0.44771,1,1S12.55229,14.00024,12,14.00024
	z M17,18.00024c-0.55228,0-1-0.44772-1-1s0.44772-1,1-1s1,0.44772,1,1S17.55228,18.00024,17,18.00024z M17,14.00024
	c-0.55228,0-1-0.44771-1-1s0.44772-1,1-1s1,0.44771,1,1S17.55228,14.00024,17,14.00024z"
      />
    </svg>
  )
}

export default CalendarIcon
